export function EmptyChat() {
  return (
    <div class="flex-1 flex items-center justify-center p-8">
      <p class="text-center text-xs text-gray-600 max-w-xs">
        Pick an agent in the rail on the left, or click ＋ to start one from the team.
      </p>
    </div>
  );
}
